// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2604":"7f937beef8854dcf","6957":"0c8c574d1ca784cc"}[chunkId] + ".css";
};